export default class InvalidArgumentException extends Error {
	constructor(name: string, value: string) {
		super(`InvalidArgumentException: name:${name}, value:${value}`);
		this.name = "InvalidArgumentException";
	}
}
